import { restRequest } from "vrcore-dashboard/dist/utilities";
export const VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX = "VRCORE.JOB_PACK_PROFILE_SELECTED_INDEX";
export const VRCORE_GET_JOB_PACKS = restRequest("VRCORE.JOB_PACK_PROFILE_GET_JOB_PACKS");
export const VRCORE_PROFILE_EDIT_SELECTED_TAB = "VRCORE.JOB_PACK_PROFILE_EDIT_SELECTED_TAB";
export const VRCORE_POST_EDITED_USER = restRequest("VRCORE.JOB_PACK_PROFILE_POST_EDITED_USER");
export const VRCORE_REMOVE_JOB_PACK = restRequest("VRCORE.JOB_PACK_PROFILE_REMOVE_JOB_PACK");
export const GET_REPORT_TITLES = restRequest("VRCORE.JOB_PACK_PROFILE_GET_REPORT_TITLES");
export const VRCORE_GET_ALL_USERS = restRequest("VRCORE.JOB_PACK_PROFILE_GET_ALL_USERS");
export const VRCORE_UPLOAD_FILE = restRequest("VRCORE.JOB_PACK_PROFILE_UPLOAD_FILE");
export const VRCORE_REMOVE_FILE = restRequest("VRCORE.JOB_PACK_PROFILE_REMOVE_FILE");
export const VRCORE_GET_TEMPLATES = restRequest("VRCORE.JOB_PACK_PROFILE_GET_TEMPLATES");

export const VRCORE_SET_FILES = restRequest("VRCORE.JOB_PACK_PROFILE_SET_FILES");
